import React from 'react';
import styled from 'styled-components';
import Button from 'components/button';
import { navigateToLeaseApplication } from '../../utils/navigate';

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 5px;
  z-index: 200;
  background-color: #fff;
  border-top: 1px solid #ddd;
`;

const CTA = styled(Button)`
  flex: 1;
  border-radius: 4px !important;
  height: 32px;
`;

export default ({ location, floorplan }) => {
  const {
    handleWaitList,
    handleApply,
    handleShowing,
    applyEnabled,
    showingEnabled,
    waitListEnabled
  } = React.useMemo(() => {
    const representativeItem = floorplan || location;

    const handleApply = () => {
      navigateToLeaseApplication({ location: representativeItem });
    };
    const handleShowing = () => {
      if (['custom', 'rently', 'showmojo'].includes(representativeItem.aptlyShowings?.type)) {
        // This goes to app create, it will bounce and redirect as needed
        window.open(representativeItem.aptlyShowings.link, '_blank');
      } else {
        // This goes to app create, it will bounce and redirect as needed
        window.open(
          `/${location.companyInfo.id}/showing/app/showing/create/?cId=${representativeItem._id}`,
          '_blank'
        );
      }
    };
    const handleWaitList = () => {
      window.open(representativeItem?.waitList?.link, '_blank');
    };
    const contactUsEnabled = !!representativeItem?.aptlyListings?.contactFormUrl;
    const showingEnabled = !!representativeItem?.aptlyShowings?.active;
    const applyEnabled = !!representativeItem?.aptlyScreening?.active;
    const waitListEnabled =
      !!representativeItem?.waitList?.link &&
      !!representativeItem?.waitList?.enabled &&
      !applyEnabled;

    return {
      handleWaitList,
      handleApply,
      handleShowing,
      waitListEnabled,
      applyEnabled,
      contactUsEnabled,
      showingEnabled
    };
  }, [location, floorplan]);
  return (
    <Wrapper className="mobileCTAS">
      {showingEnabled && (
        <CTA variant="primary" onClick={handleShowing}>
          Tour
        </CTA>
      )}
      {applyEnabled && (
        <CTA variant="secondary" onClick={handleApply}>
          Apply
        </CTA>
      )}
      {waitListEnabled && (
        <CTA variant="secondary" onClick={handleWaitList}>
          Waitlist
        </CTA>
      )}
    </Wrapper>
  );
};
